import { z } from "zod"

export const SuggestedMessagingAreaSchema = z.enum([
  "Greetings Card > Free-Form > Front",
  "Insert Card > Text Only > Front",
  "Bridal Insert > Text Only > Front",
  "Bridal Insert > Image Upload > Front",
  "Bridal Greetings Card > Free-Form > Front",
  "Bridal Greetings Card > Image Upload > Front"
])
export type SuggestedMessagingArea = z.infer<typeof SuggestedMessagingAreaSchema>

export const SuggestedMessagingSchema = z.array(z.object({
  name: z.string().default(""),
  suggestions: z.array(z.string()).default([]),
  area: z.array(SuggestedMessagingAreaSchema).default([]),
  priority: z.number().default(0)
}))

export type SuggestedMessaging = z.infer<typeof SuggestedMessagingSchema>
